import { useState } from 'react';
import AlienHead from '../../../../assets/images/characters/alien.png';
import ChestPanel from '../../../../assets/svg/chests/chest-panel.svg';
import Button from '../../../../Components/Button';
import { getChestIcon } from '../../../../Components/utils/getChestIcon';
import ChestContainsModal from '../../../../templates/ChestContainsModal';
import { TChestResponse, TChestRewardHistory } from '../../../../types';

type TChestHeadingProps = {
  hasContains?: boolean
  chest: TChestResponse;
  rewardToCollect: TChestRewardHistory | undefined
}

function ChestHeading({ hasContains, chest, rewardToCollect }: TChestHeadingProps) {
  const [modalOpen, setModalOpen] = useState(false);

  const onOpen = () => {
    setModalOpen(true);
  };

  const onClose = () => {
    setModalOpen(false);
  };

  if (!chest) {
    return null;
  }

  return (
    <>
      <div
        className="
      relative
      mx-auto
      flex items-center justify-center
      max-w-[393px]
    "
      >
        <div className="absolute right-0 transform translate-y-[-40%] translate-x-[-29%]"><img src={AlienHead} alt="alien-head" /></div>
        <img src={ChestPanel} alt="chest-panel" className="z-[1]" />
        <div
          className="
          absolute
          h-full
          aspect-[1/1]
          transform scale-[1.5] scale-x-[-1.5] translate-x-[-92.5%] translate-y-[-27.5%]
          z-[1]
      "
        >
          {getChestIcon(chest.variant)}
        </div>
        <span
          className="
          font-Bangers
          absolute z-[1]
          top-[50%] left-[52.5%]
          transform translate-y-[-50%] translate-x-[-25%]
          text-[26px]
          gradient-text primary
          pr-1
          z-[1]
      "
        >
          {chest.variant === 'tutorial' ? 'launch' : chest.variant}
          {' '}
          chest
        </span>
        {(hasContains && !rewardToCollect) && (
        <Button
          className="
            btn navy
            absolute bottom-0
            transform
            max-w-[135px]
            py-2
            transfrom translate-y-1
            z-[1]
          "
          pureClass
          onClick={onOpen}
        >
          Chest contains
        </Button>
        )}
      </div>
      <ChestContainsModal onClose={onClose} open={modalOpen} chest={chest} />
    </>
  );
}

export default ChestHeading;
